/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ScenePrefabDialog.vue?vue&type=template&id=5ecbc83f&scoped=true&"
import script from "./ScenePrefabDialog.vue?vue&type=script&lang=js&"
export * from "./ScenePrefabDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScenePrefabDialog.vue?vue&type=style&index=0&id=5ecbc83f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecbc83f",
  null
  
)

export default component.exports